// = Libs =
import { FC } from 'react';
import clsx from 'clsx';

// = Styles =
import classes from './button-group.module.scss';

// = Types =
import { ButtonGroupProps } from './button-group.types';

const ButtonGroup: FC<ButtonGroupProps> = (props) => {
  const { children, className = '', gap = 'small', type = 'horizontal' } = props;

  return (
    <div
      className={clsx(
        {
          [classes['button-group']]: true,
          [classes[`button-group__gap--${gap}`]]: gap,
          [classes[`button-group__type--${type}`]]: type,
        },
        className
      )}>
      {children}
    </div>
  );
};

export default ButtonGroup;
